"use client";

import { useEffect, useState } from 'react';
import { useRouter } from 'next/navigation';
import HeaderOpt from "@/components/organisms/HeaderOpt";
import footerData from "@/data/static-footer-data.json";
import Footer from "@organisms/Footer";
import {programsData} from "@/data/static-programs-data";
import ProgramList from '@/components/organisms/SimilarProgramsSection/ProgramList';
import { associatedPrograms } from '../(primary)/mba-campus-immersion-online/pageJSON';

export default function GlobalError({ error, reset }: { error: Error; reset: () => void }) {
  const router = useRouter();

  useEffect(() => {
    console.error('Client error:', error);
    //router.push('/500');
  }, [error, router]);

  return (
    <>
        <HeaderOpt associatedPrograms={associatedPrograms}/>
        <div style={{ textAlign: 'center', padding: '50px' }}>
          <h1>We’re currently experiencing heavy traffic. Please try again later.</h1>
          <p> </p>
          <a href="/" style={{color : "blue"}}>Go to Home</a>
        </div>
        <div className='pl=[6.25rem] pr=[6.25rem] max-w-[85%] m-auto'>
        <ProgramList programs={programsData} />
        </div>
      <Footer footerData={footerData} />
    </>
  );
}
